// Thin host wrapper — Home. Direction A (terminal feed) is for REAL
// paid subscribers only; trial / teaser / expired viewers get the
// editorial conversion surface (Direction B) with the PRD §4 Stream 2
// funnel: trial = Focus only, post-trial = hard paywall.
//
// IMPORTANT: we gate on the REAL paid tier (vm.subscriberTier from
// user_active_tier()), NOT useUserTier().tierCode — the latter
// collapses trial → 'sika_pro', which previously leaked the full
// Value/Power terminal feed to trial users (PRD violation).
// Purchase/upgrade callbacks NAVIGATE only — never charge.
import { useParams, useNavigate } from "react-router-dom";
import { tierMeets } from "../../auth/tier-gates.ts";
import { useIntlAccaHome } from "../../intl-acca/useIntlAccaHome.ts";
import { openShareCard } from "../../intl-acca/shareCardEndpoint.ts";
import { IntlAccaHomePage } from "./IntlAccaHomePage.tsx";
import { IntlAccaHomePageEditorial } from "./IntlAccaHomePageEditorial.tsx";

export function IntlAccaHomeRoute(): JSX.Element {
  const { tournamentId = "" } = useParams();
  const navigate = useNavigate();
  const vm = useIntlAccaHome(tournamentId);

  const realPaid = tierMeets(vm.subscriberTier, "sika_pro");

  if (!realPaid) {
    return (
      <IntlAccaHomePageEditorial
        loading={vm.loading}
        error={vm.error}
        tournament={vm.tournament}
        focusSlip={vm.focus}
        existingPass={vm.existingPass}
        matchLabels={vm.matchLabels}
        phase={vm.trialPhase}
        trialDay={vm.trialDay}
        onPurchasePass={() => navigate("/intl-acca/pass")}
        onUpgrade={() => navigate("/intl-acca/pass")}
      />
    );
  }

  return (
    <IntlAccaHomePage
      loading={vm.loading}
      error={vm.error}
      tournament={vm.tournament}
      slips={vm.slips}
      existingPass={vm.existingPass}
      matchLabels={vm.matchLabels}
      tier={{
        canSeeFocus: tierMeets(vm.subscriberTier, "sika_pro"),
        canSeeValue: tierMeets(vm.subscriberTier, "sika_pro"),
        canSeePower: tierMeets(vm.subscriberTier, "phantom_pro"),
      }}
      complimentaryPass={tierMeets(vm.subscriberTier, "sika_pro")}
      onUpgradeFocus={() => navigate("/intl-acca/pass")}
      onUpgradeValue={() => navigate("/intl-acca/pass")}
      onUpgradePower={() => navigate("/intl-acca/pass")}
      onPurchasePass={() => navigate("/intl-acca/pass")}
      onSharePass={() => navigate("/intl-acca/pass")}
      onShareSlip={(slipId) => openShareCard(slipId, vm.referralCode)}
    />
  );
}
